"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 9,
  fill: "var(--sds--ursa-icons--background-color, var(--smar--com--color--red--75,#fbc6c9))"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9.636 9.29c.11.006.18.008.25.014a.714.714 0 0 1-.034 1.427q-1 .014-1.997 0a.7.7 0 0 1-.693-.694 78 78 0 0 1 0-1.996.715.715 0 0 1 1.43.024v.222c.06-.048.097-.075.131-.104 1.961-1.639 4.87-1.567 6.743.166a5.06 5.06 0 0 1 1.511 2.563.715.715 0 0 1-.504.878.706.706 0 0 1-.879-.52 3.693 3.693 0 0 0-5.883-2.04zm5.77 6.663c-.638.55-1.322.933-2.103 1.12-1.896.455-3.555 0-4.95-1.36-.671-.655-1.101-1.458-1.328-2.368-.087-.351.056-.676.359-.835a.7.7 0 0 1 .876.177c.07.084.12.194.151.3.45 1.571 1.474 2.52 3.084 2.783 1.05.17 2-.13 2.873-.815l-.179-.01c-.427-.015-.735-.325-.728-.733.006-.396.327-.7.745-.701a333 333 0 0 1 1.896 0c.424 0 .735.302.737.723q.008.97 0 1.939a.714.714 0 0 1-.71.722.725.725 0 0 1-.723-.728z"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=ApprovalStatusError24.js.map